import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditoriaEntidadDto } from '@models/auditoria/auditoriaEntidadDto.model';

@Injectable({
  providedIn: 'root'
})
export class AuditoriaService {

  constructor(private http: HttpClient) { }

  /**
   * Auditoría de un registro cualquiera.
   * @param nombreEntidad nombre de la tabla, tal cual está en la base (Movimientos, Contratos, ...)
   * @param id id del registro
   */
  getAuditoriaEntidad(nombreEntidad: string, id: number): Observable<AuditoriaEntidadDto> {
    return this.http.get<AuditoriaEntidadDto>(
      "/api/Auditoria/GetAuditoriaEntidad?nombreEntidad=" + encodeURIComponent(nombreEntidad) + "&id=" + id
    )
  }
}
